import React, { useContext, useEffect } from "react";
import "./LessonDetails.scss";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "rsuite";
import { LanguageContext } from "../../app/context";
import { useGetLessonByIdQuery } from "../../entities/Lesson/lessonApi";
import {
	useGetUserByIdQuery,
	useVerifyUserQuery,
} from "../../entities/User/userApi";
import LowerPart from "./components/LowerPart";
import UpperPart from "./components/UpperPart";

const LessonDetails = () => {
	const { id = "" } = useParams();
	const { data: lessonData, isLoading: isLessonLoading = false } =
		useGetLessonByIdQuery(id);
	const navagation = useNavigate();

	const { data: verifiedUser } = useVerifyUserQuery();

	const { data: userData, isLoading: isUserLoading } = useGetUserByIdQuery(
		verifiedUser?.user.id ?? "",
	);

	const { language, setLanguage } = useContext(LanguageContext);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		setLanguage(lessonData?.language || "");
	}, [language]);

	if (isLessonLoading || isUserLoading) {
		return <Loader center content="loading" vertical />;
	}

	const isAllowedToDoLesson = userData?.enrolledCourses?.some((course) => {
		return course.lessons.some((lesson) => lesson._id === id);
	});

	if (!isAllowedToDoLesson) {
		navagation("/courses");
	}

	return (
		<div className="lesson-details">
			{lessonData && <UpperPart data={lessonData} />}
			{lessonData && <LowerPart data={lessonData} />}
		</div>
	);
};

export default LessonDetails;
